import { autoinject } from 'aurelia-framework';

@autoinject
export class Utility {

}

export const objectToQueryString = (queryParameters, addZeroValues = false) => {
    let params = queryParameters ? JSON.parse(JSON.stringify(queryParameters)) : null; // Create a shallow copy to not alter current filters
    return params
        ? Object.entries(params).reduce((queryString, [key, val], index) => {
            const symbol = queryString.length === 0 ? '?' : '&';
            if (val instanceof Date) {
                let hours = val.getHours() > 9 ? val.getHours().toString() : `0${val.getHours()}`;
                let minutes = val.getMinutes() > 9 ? val.getMinutes().toString() : `0${val.getMinutes()}`;
                let seconds = val.getSeconds() > 9 ? val.getSeconds().toString() : `0${val.getSeconds()}`;
                let milliSeconds = val.getMilliseconds() > 99 ?
                 (val.getMilliseconds() > 9 ?
                    val.getMilliseconds().toString() :
                    `0${val.getMilliseconds()}`) :
                 `00${val.getMilliseconds()}`;
                val = `${val.getFullYear()}-${(val.getMonth() + 1)}-${val.getDate()}T${hours}:${minutes}:${seconds}.${milliSeconds}Z`;
            }
            if (key === 'searchText' && !!val) {
                val = encodeURIComponent(val as string);
            }
            queryString += val || ((val === 0 || val === false) && addZeroValues) ? `${symbol}${key}=${val}` : '';
            return queryString;
        }, '')
        : '';
};